module.exports = "/_next/static/images/29-1-9be8a77b00b0b6ab3a5723071712f08a.jpg";